import { createSelector } from "reselect";
import { AppState } from "../store";

const selector = (state: AppState) => state.notificationReducer;

export const notificationSelector = createSelector([ selector ], (state) => state);
